class AzSearchBar extends HTMLElement {
    constructor() {
        super();

        this.searchInput = this.querySelector(".az-search-bar-input");
        this.searchList = this.querySelector(".az-predict-search-list");
        this.popularProductsDropdown = this.querySelector(".az-popular-products-search");
        this.serachForm = this.querySelector("#az-search-bar-form");
        this.searchListItemTemplate = this.querySelector("#az-search-list-item-template");
        this.searchInputLabel = this.querySelector(".az-search-bar-input-label");
        this.popularSearchs = this.querySelectorAll(".az-popular-searches-list-item");
        this.seachProductCards = this.querySelectorAll(".az-search-bar-product-card");

        this.initialSetup();
    }

    initialSetup() {
        this.searchInput.addEventListener("focus", this.openSearchList.bind(this));
        this.searchInput.addEventListener("input", this.debounce(this.loadPredictiveSearch.bind(this), 300));
        this.serachForm.addEventListener('submit', this.handleSubmit.bind(this));

        this.shop = window.Shopify.shop;
        this.pageTemplate = this.dataset.pageTemplate;
        this.predictCache = {};
        this.boundCloseSearchList = this.closeSearchList.bind(this);
        this.searchSubmitted = false;

        if (this.pageTemplate == "search") {
            this.searchEvent = new CustomEvent("formSubmitted", { detail: { searchQuery: "" } });
            this.searchInput.value = this.getQueryParam('q');
        }
        else if (this.pageTemplate == "product" && this.getQueryParam('source') == "az-search") {
            setTimeout(() => {
                document.querySelectorAll('form[action="/cart/add"]').forEach(element => {
                    const hiddenInput = document.createElement("input");
                    hiddenInput.type = "hidden";
                    hiddenInput.name = "attributes[_app_source]";
                    hiddenInput.value = `atomz_search`;
                    element.appendChild(hiddenInput);

                    const searchHistory = sessionStorage.getItem("atomz.ai") + ` -> product '${window.location.pathname.split("/").pop()}', US CST: ${new Date().toLocaleString("en-US", { timeZone: "America/Chicago" })}`;
                    const hiddenSearchHistory = document.createElement("input");
                    hiddenSearchHistory.type = "hidden";
                    hiddenSearchHistory.name = "properties[_search_history]";
                    hiddenSearchHistory.value = searchHistory;
                    element.appendChild(hiddenSearchHistory); 
                });
                sessionStorage.setItem("atomz.ai", window.location.pathname);
            }, 4000);
        } else {
            sessionStorage.setItem("atomz.ai", window.location.pathname == "/" ? "/home" : window.location.pathname);
        }
        
        this.popularSearchs.forEach((li) => {
            li.addEventListener("click", () => {
                appInsights.trackEvent({
                    name: "InSearchSuggestionPromptClicked",
                    properties: {
                        promptText: li.textContent,
                        storeName: this.shop
                    }
                });
                appInsights.flush();
                this.handlePredictionSubmit(li.textContent);
            });
        });

        this.seachProductCards.forEach((card) => {
            card.querySelector(".az-link").addEventListener("click", () => {
                appInsights.trackEvent({
                    name: "InSearchProductClicked",
                    properties: {
                        productTitle: card.querySelector(".az-search-bar-product-card-title").textContent,
                        storeName: this.shop
                    }
                });
                appInsights.flush();
            });
        });
    }

    debounce(func, delay) {
        let timer;
        return function (...args) {
            clearTimeout(timer);
            timer = setTimeout(() => func.apply(this, args), delay);
        };
    }

    openSearchList() {
        this.searchSubmitted = false;
        if (this.searchInput.value == '') {
            this.toggleListDisplay(this.popularProductsDropdown, this.searchList);
        } else {
            this.loadPredictiveSearch();
            this.toggleListDisplay(this.searchList, this.popularProductsDropdown);
        }
        document.addEventListener("click", this.boundCloseSearchList);
    }

    closeSearchList(event) {
        if (!this.searchInput.contains(event.target)) {
            this.toggleListDisplay(this.searchList, this.popularProductsDropdown, true);
            this.searchInput.blur();
            document.removeEventListener("click", this.boundCloseSearchList);
        }
    }

    toggleListDisplay(openElement, closeElement, closeBoth = false) {
        if (closeBoth) {
            openElement.style.display = "none";
            openElement.style.opacity = "0";
        } else {
            openElement.style.display = "block";
            openElement.style.opacity = "1";
        }
        closeElement.style.display = "none";
        closeElement.style.opacity = "0";
    }

    async loadPredictiveSearch() {
        if (this.predictCache[this.searchInput.value] && this.searchInput.value != '') {
            this.showPredictions(this.predictCache[this.searchInput.value]);
        } else if (this.searchInput.value == '') {
            this.toggleListDisplay(this.popularProductsDropdown, this.searchList);
        } else {
            try {
                let predictions = [];
                const response = await fetch(`search/suggest.json?q=${this.searchInput.value}&resources[type]=query`);
                const predictiveSearch = await response.json();
                predictiveSearch.resources.results.queries.forEach((obj) => {
                    predictions.push(obj.text);
                })
                this.showPredictions(predictions);
                this.predictCache[this.searchInput.value] = predictions;
            } catch (error) {
                if (error.name !== "AbortError") {
                    console.error(`Error loading predictive suggestions:`, error);
                }
            }
        }
    }

    showPredictions(predictions) {
        this.searchList.innerHTML = '';
        if (!this.searchSubmitted) {
            this.toggleListDisplay(this.searchList, this.popularProductsDropdown);
        }
        if (predictions.length == 0) {
            const li = this.searchListItemTemplate.content.cloneNode(true);
            li.querySelector(".az-predict-search-list-text").innerHTML = `Search For <b>"${this.searchInput.value}"</b>`;
            li.querySelector('li').addEventListener('click', () => { this.handlePredictionSubmit(this.searchInput.value); });
            this.searchList.appendChild(li);
        } else {
            predictions.forEach((word) => {
                const li = this.searchListItemTemplate.content.cloneNode(true);
                li.querySelector(".az-predict-search-list-text").textContent = word;
                li.querySelector('li').addEventListener('click', () => { this.handlePredictionSubmit(word); });
                this.searchList.appendChild(li);
            })
        }
    }

    handleSubmit(event) {
        if (this.searchInput.value == '') {
            event.preventDefault();
            return;
        }
        if (this.pageTemplate == "search") {
            event.preventDefault();
            this.triggerEvent(this.searchInput.value);
            this.toggleListDisplay(this.searchList, this.popularProductsDropdown, true);
            setTimeout(() => {
                this.searchInput.blur();
            }, 0);
        }
    }

    handlePredictionSubmit(word) {
        if (this.pageTemplate == "search") {
            this.triggerEvent(word);
            this.searchInput.value = word;
        } else {
            this.searchInput.value = word;
            this.serachForm.submit();
        }
    }

    triggerEvent(searchQuery) {
        this.searchSubmitted = true;
        this.searchEvent.detail.searchQuery = searchQuery;
        this.serachForm.dispatchEvent(this.searchEvent);
        this.updateQueryParam('q', searchQuery);
    }

    getQueryParam(param) {
        const urlObj = new URL(window.location.href);
        return urlObj.searchParams.get(param);
    }

    updateQueryParam(param, newVal) {
        const urlObj = new URL(window.location.href);
        urlObj.searchParams.set(param, newVal);
        window.history.replaceState(null, '', urlObj.toString());
    }
}

customElements.define('az-search-bar', AzSearchBar);

class AnimatedText extends HTMLElement {
    constructor() {
        super();
        this.text = this.dataset.text;
        if (this.text) {
            this.text = this.text.split(",");
            this.textElemet = this.querySelector("#animation-text");
            this.textElemet.addEventListener("animationiteration", this.changeText.bind(this));
            this.currentIndex = 1;
        }
    }

    changeText() {
        this.textElemet.innerHTML = this.text[this.currentIndex];
        this.currentIndex = (this.currentIndex + 1) % this.text.length;
    }
}

customElements.define('animate-text', AnimatedText);

class AtomzSticky extends HTMLElement {
    constructor() {
        super();
        this.headerContainer = document.querySelector(".header-wrapper");
        this.divType = this.dataset.stickyType;
        this.element = this;
        if (this.headerContainer) {
            this.setInitial();
        }
    }

    setInitial() {
        let vatiableLength = 0;
        if (this.divType == "suggestions") {
            vatiableLength = document.querySelector(`atomz-sticky[data-sticky-type="search-bar"]`).offsetHeight;
            this.element.classList.add("az-sticky-div");
        } else {
            this.searchBarSection = this.closest('section[id^="shopify-section-sections"]');
            this.searchBarSection.classList.add("az-sticky-div", "az-search-bar");
            this.element = this.searchBarSection;
        }

        this.element.style.top = `${vatiableLength}px`;

        if (this.headerContainer.dataset.stickyType == "always") {
            this.element.style.top = `${this.headerContainer.offsetHeight + vatiableLength}px`;
        } else if (this.headerContainer.dataset.stickyType == "on-scroll-up") {
            let lastScrollTop = 0;
            const headerHeight = this.headerContainer.offsetHeight;
            window.addEventListener("scroll", () => {
                let scrollTop = window.scrollY;
                if (scrollTop > lastScrollTop) {
                    this.element.style.top = `${vatiableLength}px`;
                } else {
                    this.element.style.top = `${headerHeight + vatiableLength}px`;
                }
                lastScrollTop = scrollTop;
            })
        } else if (this.headerContainer.dataset.stickyType == "reduce-logo-size") {
            const logoReduceFunction = () => {
                this.element.style.top = `${this.headerContainer.offsetHeight + vatiableLength}px`;
            }
            window.addEventListener("scroll", logoReduceFunction);
        }
    }
}

customElements.define('atomz-sticky', AtomzSticky);